import { Component, createRef } from 'react';
import { Button, Col, Form, Modal, Row, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

import './Fullfillment.scss';
import Datatable from 'shared/datatable';
import { SelectDropdown } from 'shared/dropdown/Dropdown';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl } from 'shared/http';
import { fullFillmentAdd, fullFillmentList, fullFillmentUpdate, fullfillmentPendingList, invoiceDetail, locationdetail } from 'shared/settings/apiconfig';
import { ToasterMessage } from 'shared/toast/toast';
import Validators from 'shared/validators';
import { capitalizeFirstLetter } from 'shared/utils';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to create fullfillment
 * 
 * @param props
 * 
 * 
 * @return html to render fullfillment view
 * 
**/

export class Fullfillment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fullfillment: {
                trackingnumber: { value: '', error: '', valid: false, validators: [Validators.required()] },
                carrier: { value: '', error: '', valid: false, validators: [Validators.required()] },
                selectedItemOptions: { value: [], error: '', valid: false, validators: [Validators.required()] },
                shipmentstatus: { value: 'Shipped', error: '', valid: true, validators: [Validators.required()] },
                notes: {value: '', error: '', valid: true, validators: [Validators.maxLength(100)]}
            },
            irm: '',
            selectedItemDisplay: '',
            id: '',
            buyerid: this.props?.location?.state?.buyerid,
            shippingCheckboxData: [],
            fullfillmentModal: false,
            loading: false,
            searhLoading: false,
            searchData: false,
            tableData: [],
            fullfillmentMessage: { show: false, type: '', message: '' },
            formValid: false,
            errorType: '',
            fullfillmentList: '',
            fullfillmentirmstatus: ''
        }

        

        this.dataTable = createRef();
    }

    componentDidMount() {
        this.getfulfillmentPendingList();
        this.getInvoiceData();
    }

    getInvoiceData = () => {
        this.setState({ searhLoading: true });
        axios.get(getSellerUrl(`${invoiceDetail}/${Number(this.props.match.params.invoiceId)}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    let invoiceData = response.data.data[0];
                    this.setState({
                        saleshippingsaint: invoiceData.saleshippingsaint,
                        searhLoading: false,
                        searchData: true,
                    })
                }
            })
            .catch(error => {
                this.setState({ searhLoading: false, searchData: true, });
            });
    }

    customShippingLink = (value) => {
        return (value.shippingvendor && (value.shippingvendor).toLowerCase() === 'shipping saint') ? <a style={{ color: 'blue' }} href='https://manage.shippingsaint.com/' target='_blank' onClick={(event) => { event.stopPropagation()}}>Shipping Saint</a> : value.shippingvendor ? value.shippingvendor : 'Seller';
    }

    customName = (value) => {
        return value.datatransferstatus ? capitalizeFirstLetter(value.datatransferstatus) : '- - -';
    }

    customPickupDate = (values) => {
        if (values.pickupdate) {
            const date = moment.utc(values.pickupdate).local();
            return date.format('MM/DD/YYYY');
        }
        return '- - -';
    };

    customPickupTime = (values) => {
        if (values.pickupdate) {
            const date = moment.utc(values.pickupdate).local();
            return `${date.format('hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customShippingStatus = (value) => {
        return value.shipmentstatus && this.state?.saleshippingsaint? value.shipmentstatus : '- - -';
    }

    customirm = (value) => {
         if (value.fullfillmentirmstatus) {
            const irmStatus = {
                pickup: 'Pickup',
                ship: 'Shipping',
                deliver: 'Delivery',
            };

            return irmStatus[value.fullfillmentirmstatus || '- - -'] || '- - -';
        }
    }


    capitalizeEveryWord = (text) => {
        if (!text) return '';
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    getfulfillmentPendingList = () => {
        let data = {
            filter: [
                {field: "invoiceid", value: this.props.match.params.invoiceId, op: "=", join: "AND"}
            ]
        }
        axios.post(getSellerUrl(fullfillmentPendingList), JSON.stringify(data), getSellerHeaders()).then(response => {
            if(response.data.status == "success") {
                let pendingList = response.data.data;
                if(pendingList.length > 0) {
                    let itemids = [];
                    pendingList.map((elem) => {
                        itemids.push({ id: elem.itemid, option: elem.itemtitle });
                    })
                    this.setState({
                        shippingCheckboxData: [...itemids]
                    })
                } else {
                    this.setState({
                        shippingCheckboxData: []
                    })
                }
            }
        }).catch(error => {
            if(error.response?.status == 401 || error.response?.status == 404) {
                this.setState({
                    errorPageRedirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
            this.setState({
                shippingCheckboxData: []
            })
        })
    }

    /* check validation for input changes*/
    inputChange = (event, type) => {
        let inputError = '';
        let eventValue = event.target.value;

        for (let validator of this.state.fullfillment[event.target.name].validators) {
            inputError = validator(eventValue);
            if (inputError) break;
        }

        this.setState({
            ...this.state,
            fullfillment: {
                ...this.state.fullfillment,
                [type]: {
                    ...this.state.fullfillment[type],
                    value: eventValue,
                    error: inputError,
                    valid: !Boolean(inputError)
                }
            }
        }, () => {
            /* check for form validation */
            if (inputError)
                this.setState({
                    ...this.state,
                    formValid: false
                });
            else {
                this.checkFormValidity();
            }
        })
    }  

    checkFormValidity = () => {
        let valid = true;
        for (let control of Object.keys(this.state.fullfillment)) {
            if (!this.state.fullfillment[control].valid) {
                valid = false;
                break;
            }
        }

        this.setState({
            ...this.state,
            formValid: valid
        });
    }

    validateFullFillmentFormSave = (isUpdate=false) => {
        this.setState({ loading: true });

        let valid = true;
        let inputError = '';
        let stateData = this.state.fullfillment;
        for (let control of Object.keys(stateData)) {
            for (let validator of stateData[control].validators) {
                inputError = validator(stateData[control].value);
                if (inputError) {
                    valid = false;
                    break;
                }
            }
            stateData[control]['error'] = inputError;
        }
        this.setState({
            ...this.state,
            formValid: valid,
            fullfillment: stateData
        }, () => {
            // Update
            if (isUpdate) {
                this.updateFullfillment();
            } else { 
                // Create
                this.createFullfillment();
            }
        });
    }

    /* Save the fullfillment modal form */
    createFullfillment = () => {
        if (this.state.formValid) {
            let lineItemData = [];
            this.state.fullfillment.selectedItemOptions.value.map((elem) => {
                lineItemData.push({
                    "line_item_id": elem,
                    "quantity": 1
                })
            })
            let data = {
                "data": {
                    "invoiceid": this.props.match.params.invoiceId,
                    "trackingnumber": this.state.fullfillment.trackingnumber.value,
                    "carrier": this.state.fullfillment.carrier.value,
                    "itemid": lineItemData,
                    "buyrid": this.state.buyerid,
                    "shipmentstatus": 'Shipped',
                    "notes": this.state.fullfillment.notes.value,
                    "irm": { "pickup": false, "delivery": false, "shipping": true }
                }
            };
            axios.post(getSellerUrl(fullFillmentAdd), JSON.stringify(data), getSellerHeaders())
                .then(response => {
                    if (response.data.status === 'success') {
                        this.dataTable.current.getTableData();
                        this.getfulfillmentPendingList();
                        this.setState({
                            loading: false,
                            fullfillmentMessage: { show: true, type: 'success', message: 'Data saved successfully' }
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    fullfillment: {
                                        ...this.state.fullfillment,
                                        trackingnumber: {
                                            ...this.state.fullfillment.trackingnumber,
                                            value: ''
                                        },
                                        carrier: {
                                            ...this.state.fullfillment.carrier,
                                            value: ''
                                        },
                                        selectedItemOptions: {
                                            ...this.state.fullfillment.selectedItemOptions,
                                            value: []
                                        },
                                        shipmentstatus: {
                                            ...this.state.fullfillment.shipmentstatus,
                                            value: this.state.fullfillment.shipmentstatus.value
                                        },
                                        notes: {
                                            ...this.state.fullfillment.notes,
                                            value: ''
                                        },
                                    },
                                    selectedItemDisplay: '',
                                    buyrid: '',
                                    formValid: false,
                                    fullfillmentMessage: { show: false, type: '', message: '' }
                                })
                            }, 2000);
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false
                    })
                })
        }
    }  

    fullfillmentOption = (itemids) => {
        this.setState({
            ...this.state,
            fullfillment: {
                ...this.state.fullfillment,
                selectedItemOptions: {
                    ...this.state.fullfillment.selectedItemOptions,
                    value: [...itemids],
                    error: itemids.length == 0 ? "Please select itemids" : "",
                    valid: itemids.length == 0 ? false : true
                },
            }
        }, () => {
            this.checkFormValidity();
        })
    }

    openFullfillmentModal = (row) => {
        this.setState({
            fullfillmentModal: true,
            fullfillment: {
                ...this.state.fullfillment,
                trackingnumber: { 
                    ...this.state.fullfillment.trackingnumber,
                    value: row.trackingnumber 
                },
                carrier: { 
                    ...this.state.fullfillment.carrier,
                    value: row.carrier 
                },
                selectedItemOptions: {
                    ...this.state.fullfillment.selectedItemOptions,
                    value: [ row.itemid]
                },
                shipmentstatus: { 
                    ...this.state.fullfillment.shipmentstatus,
                    value: row.shipmentstatus 
                },
                notes: { 
                    ...this.state.fullfillment.notes,
                    value:row.notes 
                },
            },
            id: row.id,
            buyrid: row.buyrid,
            selectedItemDisplay: row.itemid
        })
    }

    updateFullfillment = () => {
        let lineItemData = [];
        this.state.fullfillment.selectedItemOptions.value.map((elem) => {
            lineItemData.push({
                "line_item_id": elem,
                "quantity": 1
            })
        })
        if (this.state.formValid) {
            let data = {
                "data": {
                    "invoiceid": this.props.match.params.invoiceId,
                    "trackingnumber": this.state.fullfillment.trackingnumber.value,
                    "carrier": this.state.fullfillment.carrier.value,
                    "itemid": lineItemData,
                    "id": this.state.id,
                    "buyrid": this.state.buyerid,
                    "shipmentstatus": 'Shipped',
                    "notes": this.state.fullfillment.notes.value,
                    "irm": { "pickup": false, "delivery": false, "shipping": true }
                }
            };

            axios.put(getSellerUrl(fullFillmentUpdate), JSON.stringify(data), getSellerHeaders())
                .then(response => {
                    if (response.data.status === 'success') {
                        this.dataTable.current.getTableData();
                        this.setState({
                            loading: false,
                            fullfillmentMessage: { show: true, type: 'success', message: 'Data Updated successfully' },

                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    fullfillment: {
                                        ...this.state.fullfillment,
                                        trackingnumber: {
                                            ...this.state.fullfillment.trackingnumber,
                                            value: ''
                                        },
                                        carrier: {
                                            ...this.state.fullfillment.carrier,
                                            value: ''
                                        },
                                        selectedItemOptions: {
                                            ...this.state.fullfillment.selectedItemOptions,
                                            value: []
                                        },
                                        shipmentstatus: {
                                            ...this.state.fullfillment.shipmentstatus,
                                            value: this.state.fullfillment.shipmentstatus.value
                                        },
                                        notes: {
                                            ...this.state.fullfillment.notes,
                                            value: ''
                                        },
                                    },
                                    selectedItemDisplay: '',
                                    fullfillmentModal: false,
                                    fullfillmentMessage: { show: false, type: '', message: '' }
                                })
                            }, 2000);
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        fullfillmentMessage: { show: true, type: 'danger', message: 'Data not saved successfully' },
                        loading: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                fullfillmentMessage: { show: false, type: '', message: '' }
                            })
                        }, 2000);
                    })
                })
        }
    }
    

    resetFullfillment = () => {
        this.setState({
            fullfillment: {
                ...this.state.fullfillment,
                trackingnumber: {
                    ...this.state.fullfillment.trackingnumber,
                    value: '',
                    error: ''
                },
                carrier: {
                    ...this.state.fullfillment.carrier,
                    value: '',
                    error: ''
                },
                selectedItemOptions: {
                    ...this.state.fullfillment.selectedItemOptions,
                    value: [],
                    error: ''
                },
                shipmentstatus: {
                    ...this.state.fullfillment.shipmentstatus,
                    value: this.state.fullfillment.shipmentstatus.value,
                    error: ''
                },
                notes: {
                    ...this.state.fullfillment.notes,
                    value: '',
                    error: ''
                },
            },
            selectedItemDisplay: '',
            fullfillmentModal: false,
            fullfillmentMessage: { show: false, type: '', message: '' }
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    updateStateData = (event) => {
        this.setState({
            ...this.state,
            fullfillmentList: event
        });

    }

    navigateToDashboard = () => {
        if(this.props.match.params.invoiceId) {
            this.props.history.push({pathname : `/invoice/view/${this.props.match.params.invoiceId}`, state: this.props.location.state});
        } else {
            this.props.history.goBack();
        }
    }

    clearFulfillmentOption = () => {
        this.setState({
            fullfillment: {
                ...this.state.fullfillment,
                selectedItemOptions: {
                    ...this.state.fullfillment.selectedItemOptions,
                    value: [],
                    valid: false,
                    error: ""
                }
            },
            formValid: false,
            selectedItemDisplay: ''
        })
    }

    /* called when clicking on accordion */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div>
                <div className="accordion-item">
                    {row && Object.keys(row).length ?
                        <div className="d-flex">
                            <div className="mx-2" style={{ width: "calc(100%/4)" }}>
                                <h6>Fullfillment Created By</h6>
                                <div>{row['createdby'] ? this.capitalizeEveryWord(row['createdby']) : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/4)" }}>
                                <h6>Fullfillment Created Date and Time</h6>
                                <div>{row['createddate'] ? `${moment.utc(row['createddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/4" }}>
                                <h6>Updated By</h6>
                                <div>{row['updatedby'] ? this.capitalizeEveryWord(row['updatedby']) : ''}</div>
                            </div>
                            <div className="mx-2" style={{ width: "calc(100%/4)" }}>
                                <h6>Last Modified</h6>
                                <div>{row['modifieddate'] ? `${moment.utc(row['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : ''}</div>
                            </div>
                        </div>
                        : ''}
                </div>
            </div>
        );
    }

    render() {
        this.config = {
            name: 'fullfillment',
            url: fullFillmentList,
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: this.state?.saleshippingsaint ? '' : ['edit'], customHeader: <> </>, width: (this.state?.saleshippingsaint) ? '-50px' :'50px',
                    actionEvents: { edit: (row) => { this.openFullfillmentModal(row) } }
                },
                { name: 'Data Transfer Status', property: 'datatransferstatus', sort: false, width: '200px',columnType: 'custom', customColumn: this.customName  },
                { name: 'Shipping Vendor', property: 'shippingvendor', sort: false, width: '120px', columnType: 'custom', customColumn: this.customShippingLink },
                { name: 'Shipping Status', property: 'shipmentstatus', sort: false, width: '120px', columnType: 'custom', customColumn: this.customShippingStatus },
                { name: 'Item Title', property: 'itemtitle', sort: false, width: '150px' },
                { name: 'Tracking Number', property: 'trackingnumber', sort: false, width: '150px' },
                { name: 'Carrier', property: 'carrier', sort: false, width: '150px' },
                { name: 'Pickup Date', property: 'pickupdate', sort: false, width: '120px',columnType: 'custom', customColumn: this.customPickupDate },
                { name: 'Pickup Time', property: 'pickupdate', sort: false, width: '120px',columnType: 'custom', customColumn: this.customPickupTime },
                { name: 'Item Receipt Method', property: 'irm', sort: false, width: '150px', columnType: 'custom', customColumn: this.customirm},
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '25px',
                    accordion: this.accordionValue,
                }
            ],
            field: ["id", "itemid", "buyrid", "orderid","datatransferstatus", "invoiceid", "fullfillmentid","pickupdate", "fullfillmentresponse", "fullfillmentstatus", "carrier", "fullfillmentirmstatus",
                "trackingnumber", "shipmentstatus", "trackingDetails", "itemtitle", "irm","notes","saleid","saletitle", "locationid", "shippingvendor", "createdby", "updatedby", "modifieddate", "createddate"],
            defaultFilter: [{ field: "invoiceid", value: this.props.match.params.invoiceId, op: "=", join: "AND" }],
            sort: [{ field: 'id', direction: 'desc' }],
            pagination: true,
            ignoreRowBackground: true
        };
        
        if (this.state.fullfillmentList.error && this.state.errorPageRedirect) {
            return <NoData {...this.props} type={this.state.fullfillmentList.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                    <span onClick={this.navigateToDashboard} className="clickable">
                        <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                        <span style={{ paddingLeft: "1em" }}>Back</span>
                    </span>
                </div>

                {this.state.searhLoading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <>
                {!this.state.saleshippingsaint && <div className="fullfillment-create">
                    <div className="fulliment-list-create">
                        <Form className="fullfillment-list-font">
                            <div className="fullfillment-create-container">
                                <Row>
                                    <Col>
                                        <label>Item Receipt Method</label>
                                        <Form.Control type="text" name="irm" value="Shipping" disabled />
                                    </Col>
                                    <Col style={{ cursor : Object.keys(this.state.shippingCheckboxData).length == 0 ? "not-allowed" : '' }}>
                                        <label>Select Items *</label>
                                        <SelectDropdown multiple shippingSaint={this.state?.saleshippingsaint} placeholder="Select item" id="selectedItemOption"  value={this.state.fullfillment.selectedItemOptions.value} onChange={(event) => { this.fullfillmentOption(event) }} onClear={() => { this.clearFulfillmentOption() }}
                                            data={this.state.shippingCheckboxData} required />
                                        {this.state.shippingCheckboxData.length == 0 ? <span className='text-danger'>No items available</span> : ''}
                                        <span className='text-danger'>
                                            {
                                                this.state.fullfillment.selectedItemOptions.error && this.state.fullfillment.selectedItemOptions.error.length ? <small className="error">{this.state.fullfillment.selectedItemOptions.error}</small> : null
                                            }
                                        </span>
                                    </Col>
                                    <Col>
                                        <label>Tracking Number *</label>
                                        <Form.Control type="text" id="trackingnumber" name="trackingnumber" className={`${this.state?.saleshippingsaint? 'shipping-item-hide' : ''}`} value={this.state.fullfillment.trackingnumber.value} required onChange={(event) => this.inputChange(event, "trackingnumber")} disabled={this.state?.saleshippingsaint} />
                                        <span className='text-danger'>
                                            {
                                                this.state.fullfillment.trackingnumber.error && this.state.fullfillment.trackingnumber.error.length ? <small className="error">{this.state.fullfillment.trackingnumber.error}</small> : null
                                            }
                                        </span>
                                    </Col>
                                    <Col>
                                        <label>Carrier *</label>
                                        <Form.Control type="text" id="carrier" name="carrier" className={`${this.state?.saleshippingsaint ? 'shipping-item-hide' : ''}`} value={this.state.fullfillment.carrier.value} required onChange={(event) => this.inputChange(event, "carrier")} disabled={this.state?.saleshippingsaint} />
                                        <span className='text-danger'>
                                            {
                                                this.state.fullfillment.carrier.error && this.state.fullfillment.carrier.error.length ? <small className="error">{this.state.fullfillment.carrier.error}</small> : null
                                            }
                                        </span>
                                    </Col>
                                </Row>
                                <Row>
                                    {/* <Col>
                                        <label>Shipping Status *</label>
                                        <Form.Control as="select" id="shipmentstatus" name="shipmentstatus" value={this.state.fullfillment.shipmentstatus.value} className={this.state.fullfillment.shipmentstatus.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event, "shipmentstatus")}>
                                            <option selected value={''} disabled={this.state.fullfillment.shipmentstatus.value ? true : false }>Select Status</option>
                                            <option value="Shipped">Shipped</option>
                                            <option value="Delivered">Delivered</option>
                                        </Form.Control>
                                        <span className='text-danger'>
                                            {
                                                this.state.fullfillment.shipmentstatus.error && this.state.fullfillment.shipmentstatus.error.length ? <small className="error">{this.state.fullfillment.shipmentstatus.error}</small> : null
                                            }
                                        </span>
                                    </Col> */}
                                    <Col>
                                        <label>Notes</label>
                                        <Form.Control as="textarea" name="notes" id="notes" className={`${this.state?.saleshippingsaint ? 'shipping-item-hide' : ''}`} value={ this.state.fullfillment.notes.value} onChange={(event) => this.inputChange(event, "notes")} disabled={this.state?.saleshippingsaint} />
                                        <span className='text-danger'>
                                            {
                                                this.state.fullfillment.notes.error && this.state.fullfillment.notes.error.length ? <small className="error">{this.state.fullfillment.notes.error}</small> : null
                                            }
                                        </span>
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    {
                                        this.state.fullfillmentMessage.show ?
                                            <ToasterMessage type={this.state.fullfillmentMessage.type} message={this.state.fullfillmentMessage.message} className="alert-handle mt-2"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <Row className="buttonClass">
                                    <Col>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <Button variant="seller-search" onClick={() => this.validateFullFillmentFormSave(false)} disabled={this.state.shippingCheckboxData.length == 0 || !this.state.formValid}>Create {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>}
                <div className="fullfillment-list">
                    <Datatable {...this.props} config={{ ...this.config }} ref={this.dataTable} search={this.state.searchData ? { search: {}, searchData: this.state.searchData } : null} onDataUpdate={this.updateTableData} onDataUpdateStatus={this.updateStateData}></Datatable>
                </div>
                </>}

                <Modal centered show={this.state.fullfillmentModal} size='xl' id="fullfillmentModal">
                    <Modal.Body>
                        <h5 className="text-secondary">Update Fulfillment</h5>
                        <Form>
                            <div className="float-control">
                                <Form.Control type="text" id="irm" name="irm" placeholder=" " value={"Shipping"} className='form-control-active' disabled />
                                <label htmlFor="irm" className="required">Item Receipt Method</label>
                            </div>
                            <div className="float-control">
                                <div className="text">
                                    {
                                        this.state.fullfillment.selectedItemOptions.error && this.state.fullfillment.selectedItemOptions.error.length ? <small className="error">{this.state.fullfillment.selectedItemOptions.error}</small> : null
                                    }
                                </div>
                                <Form.Control type="number" id='itemid' name="itemid" value={this.state.selectedItemDisplay} disabled />
                                <label htmlFor="itemid" className="required">Item Id</label>
                            </div>
                            <div className="float-control">
                                <div className="text">
                                    {
                                        this.state.fullfillment.trackingnumber.error && this.state.fullfillment.trackingnumber.error.length ? <small className="error">{this.state.fullfillment.trackingnumber.error}</small> : null
                                    }
                                </div>
                                <Form.Control type="text" id="trackingnumber" name="trackingnumber" className={`form-control-active ${this.props?.location?.state?.saleshippingsaint ? 'shipping-item-hide' : ''}`} placeholder=" " value={this.state.fullfillment.trackingnumber.value} disabled={this.props?.location?.state?.saleshippingsaint} onChange={(event) => this.inputChange(event, 'trackingnumber')} />
                                <label htmlFor="trackingnumber" className="required">Tracking Number</label>
                            </div>
                            <div className="float-control">
                                <div className="text">
                                    {
                                        this.state.fullfillment.carrier.error && this.state.fullfillment.carrier.error.length ? <small className="error">{this.state.fullfillment.carrier.error}</small> : null
                                    }
                                </div>
                                <Form.Control type="text" id="carrier" name="carrier" className={`form-control-active ${this.props?.location?.state?.saleshippingsaint ? 'shipping-item-hide' : ''}`} placeholder=" " value={this.state.fullfillment.carrier.value} disabled={this.props?.location?.state?.saleshippingsaint} onChange={(event) => this.inputChange(event, 'carrier')} />
                                <label htmlFor="carrier" className="required">Carrier</label>
                            </div>
                            {/* <div className='float-control'>
                                <Form.Control as="select" id="shipmentstatus" name="shipmentstatus" value={this.state.fullfillment.shipmentstatus.value} className={this.state.fullfillment.shipmentstatus.value ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.inputChange(event, "shipmentstatus")}>
                                    <option selected value={''} disabled={this.state.fullfillment.shipmentstatus.value ? true : false }>Select Status</option>
                                    <option value="Shipped">Shipped</option>
                                    <option value="Delivered">Delivered</option>
                                </Form.Control>
                                <Form.Label htmlFor="shipmentstatus" className="required">Shipping Status</Form.Label>
                            </div> */}
                            <div className="float-control">
                            <div className="text">
                                    {
                                        this.state.fullfillment.notes.error && this.state.fullfillment.notes.error.length ? <small className="error">{this.state.fullfillment.notes.error}</small> : null
                                    }
                                </div>
                                <Form.Control as="textarea" id="notes" name="notes" className={`form-control-active ${this.props?.location?.state?.saleshippingsaint ? 'shipping-item-hide' : ''}`}  placeholder=" " value={this.state.fullfillment.notes.value} disabled={this.props?.location?.state?.saleshippingsaint} onChange={(event) => this.inputChange(event, 'notes')} />
                                <label htmlFor="notes">Notes</label>
                            </div>
                            <div className='d-flex align-items-center justify-content-center text-center'>
                                {
                                    this.state.fullfillmentMessage.show ?
                                        <ToasterMessage type={this.state.fullfillmentMessage.type} message={this.state.fullfillmentMessage.message} className="alert-handle mt-2"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="mt-2">
                                <div className="d-flex justify-content-center">
                                    <Button onClick={() => this.resetFullfillment()} className="btn-white">Cancel</Button>
                                    <Button onClick={() => this.validateFullFillmentFormSave(true)} className="btn-secondary ml-2" >Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

            </div>
        );
    }
}